import { Component } from '@angular/core';

@Component({
  selector: 'app-draggable-grips',
  templateUrl: './draggable-grips.component.html',
  styleUrls: ['./draggable-grips.component.scss'],
})
export class DraggableGripsComponent {}
